import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../Url";
import { setupInterceptorsTo } from "../Authentication/Interceptors";
import {
  LogOutActionTypes,
  LOGOUT_FAIL,
  LOGOUT_LOADING,
  LOGOUT_SUCCESS,
} from "./ActionTypes";
import { LogOutResponse } from "./Model";
import { headers } from "../../components/Utility";

export const logOut = () => {
  return function (dispatch: Dispatch<LogOutActionTypes>) {
    dispatch({
      type: LOGOUT_LOADING,
    });
    setupInterceptorsTo(axios)
      .post(
        baseUrl.baseUrl + `/api/logout/`,
        { refresh_token: localStorage.getItem("refresh") },
        {
          headers: headers,
        }
      )
      .then((res) => {
        dispatch({
          type: LOGOUT_SUCCESS,
          payload: res.data,
          errRes: "",
        });
        localStorage.clear();
        window.location.reload();
      })
      .catch((error) => {
        dispatch({
          type: LOGOUT_FAIL,
          payload: {} as LogOutResponse,
          errRes: error.response.data.message,
        });
        localStorage.clear();
      });
  };
};
